export default "/images/8.png?26a4b5f3be592481dfb9283eb3871f37";